<template>
  <v-layout class="option-bar" row align-center fill-height>
    <!-- 옵션바 -->
    <v-layout row wrap align-center>
      <v-flex shrink>
        <v-flex id="opt_search_area">
          <v-layout row wrap>
            <v-flex class="hidden-md-and-up shrink">
              <router-link to="/map">
                <div class="logo svg-wrap"  @click="home()">
                  <canvas height="1" width="3"></canvas>
                  <svg-logo/>
                </div>
              </router-link>
            </v-flex>
            <v-flex class="search-box-wrap">
              <div class="search-box">
                <div class="icon-hashtag svg-wrap">
                  <canvas height="1" width="3"></canvas>
                  <icon-hash-tag/>
                </div>
                <v-icon class="icon-search" @click="submit()">search</v-icon>
                <form onsubmit="return false;" @keyup.enter="submit()">
                  <v-text-field solo label="지역명, 지하철역을 검색하세요!" v-model="filterState.search" id="search_box" autocomplete=off @click="searchInputClick">
                  </v-text-field>
                </form>
                <!-- 검색어완성 -->
                <div v-if="mapData.searchAutoView.show" id="search-auto-wrap" class="search-auto-wrap">
                  <v-layout row v-for="(velue, index) in mapData.searchAutoView.data" :key="index" @click="searchAutoAction(velue.type, velue.no, velue.level, velue.center.lat, velue.center.lng)">
                    <v-flex class="shrink">
                      <v-icon>{{getSearchAutoIcon(velue.type)}}</v-icon>
                    </v-flex>
                    <v-flex class="grow">
                      <div>{{velue.name}}</div>
                      <div v-if="velue.type === 'structure' || velue.type === 'structure_addr'" class="addr">
                        {{velue.addr}}
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex grow><!-- style="z-index: 0;" -->
        <!-- 모바일 옵션바 -->
        <span class="opt-chip-show-sm">
          <v-chip ref="mini_filter_btn_2" @click="showMiniFilter(this, 2)" class="opt-chip">{{printItemTypeInfo()/* 방유형 */}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
          <v-chip @click="showMiniFilter(this, 3)" class="opt-chip opt-chip-hidden-xs">가격 <v-icon>keyboard_arrow_down</v-icon></v-chip>
          <v-chip @click="openVideoModal()" class="opt-chip">동영상보기<v-icon size="22px" color="#ff435b" class="ml-1">play_circle_outline</v-icon></v-chip>
        </span>
        <!-- 이하 pc -->
        <span class="opt-chip-hidden-sm">
          <v-chip ref='mini_filter_btn_1' @click="showMiniFilter(this, 1)" class="opt-chip">{{printSaleTypeInfo()/* 가격유형 */}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
          <v-chip ref="mini_filter_btn_2" @click="showMiniFilter(this, 2)" class="opt-chip">{{printItemTypeInfo()/* 방유형 */}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        </span>
        <v-chip ref="mini_filter_btn_3" @click="showMiniFilter(this, 3)" class="opt-chip opt-chip-hidden-sm">{{printPriceInfo()/* 가격범위 */}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <v-chip ref="mini_filter_btn_4" @click="showMiniFilter(this, 4)" class="opt-chip opt-chip-hidden-md">{{printDateInfo()/* 준공년도 */}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <v-chip ref="mini_filter_btn_5" @click="showMiniFilter(this, 5)" class="opt-chip opt-chip-hidden-lg">추가필터 <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <!--
        <v-chip @click="filter_dialog = true" class="opt-chip">{{printSaleTypeInfo()}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <v-chip @click="filter_dialog = true" class="opt-chip">{{printItemTypeInfo()}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <v-chip @click="filter_dialog = true" class="opt-chip hidden-sm-and-down">{{printPriceInfo()}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <v-chip @click="filter_dialog = true" class="opt-chip hidden-md-and-down">{{printM2Info()}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        <v-chip @click="filter_dialog = true" class="opt-chip hidden-md-and-down">{{printDateInfo()}} <v-icon>keyboard_arrow_down</v-icon></v-chip>
        -->
        <!-- * 미니필터 * -->
        <!-- 거래유형 -->
        <div class="mini-filter" v-if="mini_filter.opt_1.show" :style="{left: mini_filter.opt_1.left}">
          <div class="filter-title">거래유형</div>
          <div class="filter-body">
            <div>
              <button type="button" class="select-btn" :class="(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1)? 'select-btn-active' : ''" @click="clickSaleType(0, true)">전체</button>
              <button type="button" class="select-btn" :class="(!(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1) && filterState.saleType.opt1 === 1)? 'select-btn-active' : ''" @click="clickSaleType(1, true)">월세</button>
              <button type="button" class="select-btn" :class="(!(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1) && filterState.saleType.opt2 === 1)? 'select-btn-active' : ''" @click="clickSaleType(2, true)">전세</button>
              <button type="button" class="select-btn" :class="(!(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1) && filterState.saleType.opt3 === 1)? 'select-btn-active' : ''" @click="clickSaleType(3, true)">매매</button>
            </div>
            <div>
              <button type="button" class="select-btn" v-if="filterState.saleType.opt1 === 1" :class="filterState.mCost === 1? 'select-btn-active' : ''" @click="filterState.mCost === 1? filterState.mCost = 0 : filterState.mCost = 1">관리비포함(월세)</button>
            </div>
            <!--
            <div class="div-line mt-2"></div>
            <div>
              <button type="button" class="select-btn right mb-0 mr-0" @click="filterSaleTypeReset()">전체보기</button>
            </div>
            -->
          </div>
        </div>
        <!-- 매물유형 -->
        <div class="mini-filter" v-if="mini_filter.opt_2.show" :style="{left: mini_filter.opt_2.left}">
          <div class="filter-title">매물유형</div>
          <div class="filter-body">
            <div>
              <button type="button" class="select-btn" :class="(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1)? 'select-btn-active' : ''" @click="clickItemType(0, true)">전체</button>
              <button type="button" class="select-btn" :class="!(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1) && filterState.itemType.opt1 === 1? 'select-btn-active' : ''" @click="clickItemType(1, true)">원룸</button>
              <button type="button" class="select-btn" :class="!(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1) && filterState.itemType.opt2 === 1? 'select-btn-active' : ''" @click="clickItemType(2, true)">투룸</button>
              <button type="button" class="select-btn" :class="!(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1) && filterState.itemType.opt3 === 1? 'select-btn-active' : ''" @click="clickItemType(3, true)">쓰리룸+</button>
              <div class="div-line mt-2"></div>
              <button type="button" class="select-btn" :class="filterState.itemType.opt4 === 1? 'select-btn-active' : ''" @click="clickItemType(4, true)">빌라분양/매매</button>
              <button type="button" class="select-btn" :class="filterState.itemType.opt5 === 1? 'select-btn-active' : ''" @click="clickItemType(5, true)">상가/사무실</button>
            </div>
          </div>
        </div>
        <!-- 가격대 -->
        <div class="mini-filter" v-if="mini_filter.opt_3.show" :style="{left: mini_filter.opt_3.left}" style="width: 400px;">
          <div class="filter-body pt-0">
            <div v-if="filterState.saleType.opt1 === 1 || filterState.saleType.opt2 === 1 || filterState.saleType.opt3 === 1">
              <div v-if="filterState.saleType.opt1 === 1 || filterState.saleType.opt2 === 1">
                <div class="filter-title"><span v-if="filterState.saleType.opt1 === 1">보증금</span><span v-if="filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1">/</span><span v-if="filterState.saleType.opt2 === 1">전세</span></div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.depositStep"
                      :max="44"
                      :min="0"
                      style="padding:0 10px;"
                      @change="autoMapUpdate()"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printDeposit}}
                  </div>
                </div>
              </div>
              <div v-if="filterState.saleType.opt1 === 1">
                <div class="filter-title">월세</div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.monthlyStep"
                      :max="30"
                      :min="0"
                      style="padding:0 10px;"
                      @change="autoMapUpdate()"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printMonthly}}
                  </div>
                </div>
              </div>
              <div v-if="filterState.saleType.opt3 === 1">
                <div class="filter-title">매매가</div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.salePriceStep"
                      :max="25"
                      :min="0"
                      style="padding:0 10px;"
                      @change="autoMapUpdate()"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printSalePrice}}
                  </div>
                </div>
              </div>
            </div>
            <div class="div-line mt-2"></div>
            <div>
              <button type="button" class="select-btn right mb-0 mr-0" @click="filterPriceReset()">전체보기</button>
            </div>
          </div>
        </div>
        <!-- 준공년도 -->
        <div class="mini-filter" v-if="mini_filter.opt_4.show" :style="{left: mini_filter.opt_4.left}">
          <div class="filter-title">준공년차</div>
          <div class="filter-body">
            <div>
              <button type="button" class="select-btn" :class="filterState.approvalDate === 0? 'select-btn-active' : ''" @click="clickApprovalDate(0, true)">전체</button>
              <button type="button" class="select-btn" :class="filterState.approvalDate === 1? 'select-btn-active' : ''" @click="clickApprovalDate(1, true)">1년이하</button>
              <button type="button" class="select-btn" :class="filterState.approvalDate === 2? 'select-btn-active' : ''" @click="clickApprovalDate(2, true)">5년이하</button>
              <button type="button" class="select-btn" :class="filterState.approvalDate === 3? 'select-btn-active' : ''" @click="clickApprovalDate(3, true)">10년이하</button>
              <button type="button" class="select-btn" :class="filterState.approvalDate === 4? 'select-btn-active' : ''" @click="clickApprovalDate(4, true)">15년이하</button>
              <button type="button" class="select-btn" :class="filterState.approvalDate === 5? 'select-btn-active' : ''" @click="clickApprovalDate(5, true)">15년이상</button>
            </div>
          </div>
        </div>
        <!-- 추가필터 -->
        <div class="mini-filter" v-if="mini_filter.opt_5.show" :style="{left: mini_filter.opt_5.left}" style="width: 460px;">
          <div v-if="filterState.itemType.opt1 === 1">
            <div class="filter-title">원룸 구조</div>
            <div class="filter-body mb-3">
              <button type="button" class="select-btn" :class="(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1 && filterState.structType.opt4 === 1)? 'select-btn-active' : ''" @click="clickStructType(0, true)">전체</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt1 === 1? 'select-btn-active' : ''" @click="clickStructType(1, true)">오픈형</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt3 === 1? 'select-btn-active' : ''" @click="clickStructType(3, true)">분리형(주방)</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt4 === 1? 'select-btn-active' : ''" @click="clickStructType(4, true)">1.5(거실&주방)</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt2 === 1? 'select-btn-active' : ''" @click="clickStructType(2, true)">복층</button>
            </div>
          </div>
          <div v-if="filterState.itemType.opt2 === 1 || filterState.itemType.opt3 === 1">
            <div class="filter-title">투/쓰리룸+ 구조</div>
            <div class="filter-body mb-3">
              <button type="button" class="select-btn" :class="(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1)? 'select-btn-active' : ''" @click="clickStructType(5, true)">전체</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1) && filterState.structType.opt6 === 1? 'select-btn-active' : ''" @click="clickStructType(6, true)">거실(소)</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1) && filterState.structType.opt7 === 1? 'select-btn-active' : ''" @click="clickStructType(7, true)">거실(중)</button>
              <button type="button" class="select-btn" :class="!(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1) && filterState.structType.opt8 === 1? 'select-btn-active' : ''" @click="clickStructType(8, true)">거실(대)</button>
            </div>
          </div>
          <div style="display: none;">
            <div class="filter-body">
              <div class="filter-title">면적</div>
              <div class="filter-slider">
                <v-flex style="position: relative;">
                  <v-range-slider
                    v-model="filterState.m2Step"
                    :max="10"
                    :min="0"
                    style="padding:0 10px;"
                  ></v-range-slider>
                  <v-flex class="filter-slider-guide">
                    <span style="float: left; margin-left:5px;">0</span>
                    <span style="float: right; margin-right:-8px;">무제한</span>
                  </v-flex>
                </v-flex>
                <div class="filter-slider-print">
                  {{printM2()}}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="filter-title">층수</div>
            <div class="filter-body mb-3">
              <button type="button" class="select-btn" :class="(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1)? 'select-btn-active' : ''" @click="clickItemFloor(0, true)">전체</button>
              <button type="button" class="select-btn" :class="!(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1) && filterState.itemFloor.opt1 === 1? 'select-btn-active' : ''" @click="clickItemFloor(1, true)">지상층</button>
              <button type="button" class="select-btn" :class="!(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1) && filterState.itemFloor.opt8 === 1? 'select-btn-active' : ''" @click="clickItemFloor(8, true)">반지층</button>
              <button type="button" class="select-btn" :class="!(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1) && filterState.itemFloor.opt9 === 1? 'select-btn-active' : ''" @click="clickItemFloor(9, true)">옥탑</button>
            </div>
          </div>
          <div>
            <div class="filter-title">옵션 필터 선택</div>
            <div class="filter-body mb-2">
              <button type="button" class="select-btn" :class="filterState.roomOption.opt1 === 1? 'select-btn-active' : ''" @click="clickRoomOption(1, true)">발코니</button>
              <button type="button" class="select-btn" :class="filterState.roomOption.opt2 === 1? 'select-btn-active' : ''" @click="clickRoomOption(2, true)">빌트인</button>
              <button type="button" class="select-btn" :class="filterState.roomOption.opt3 === 1? 'select-btn-active' : ''" @click="clickRoomOption(3, true)">동물가능</button>
              <button type="button" class="select-btn" :class="filterState.roomOption.opt4 === 1? 'select-btn-active' : ''" @click="clickRoomOption(4, true)">전세자금대출</button>
              <button type="button" class="select-btn" :class="filterState.roomOption.opt5 === 1? 'select-btn-active' : ''" @click="clickRoomOption(5, true)">비옵션(주택)</button>
            </div>
          </div>
          <div>
            <div class="filter-title">이미지 필터 선택</div>
            <div class="filter-body mb-2">
              <button type="button" class="select-btn" :class="filterState.imgOption.opt1 === 1? 'select-btn-active' : ''" @click="clickImgOption(1, true)">동영상</button>
              <button type="button" class="select-btn" :class="filterState.imgOption.opt2 === 1? 'select-btn-active' : ''" @click="clickImgOption(2, true)">사진</button>
              <button type="button" class="select-btn" :class="filterState.imgOption.opt3 === 1? 'select-btn-active' : ''" @click="clickImgOption(3, true)">2D</button>
              <button type="button" class="select-btn" :class="filterState.imgOption.opt4 === 1? 'select-btn-active' : ''" @click="clickImgOption(4, true)">3D</button>
              <button type="button" class="select-btn" :class="filterState.imgOption.opt5 === 1? 'select-btn-active' : ''" @click="clickImgOption(5, true)">VR</button>
            </div>
          </div>
        </div>
        <!-- 미니필터 -->
      </v-flex>
      <v-flex shrink>
        <v-btn outline align-center round class="opt-btn mt-1 mb-1 ml-1 mr-0 hidden-sm-and-down" @click="filter_dialog = true"><v-icon>tune</v-icon> 필터검색</v-btn>
        <v-btn outline align-center round class="opt-btn ma-1 hidden-sm-and-down" @click="filterReset()"><v-icon>refresh</v-icon> 초기화</v-btn>
        <v-btn flat icon dark color="title_color" class="mobile-opt-btn mt-1 mb-1 ml-1 mr-0 hidden-md-and-up" @click="filter_dialog = true"><v-icon>tune</v-icon></v-btn>
      </v-flex>
    </v-layout>

    <!-- 필터 모달 -->
    <v-dialog v-model="filter_dialog" fullscreen hide-overlay transition="dialog-bottom-transition" color="#ffffff">
      <v-card class="filter-dialog">
        <!-- 타이틀 툴바 title_dark1-->
        <v-toolbar flat color="#eee">
          <v-btn icon @click="filter_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class="ml-1"><span class="filter-toolbar-title">필터선택</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat class="filter-btn" @click="filterReset()"><v-icon class="mr-1">replay</v-icon> 초기화</v-btn>
            <v-btn flat class="filter-btn" @click="filterSave()"><v-icon class="mr-1">done</v-icon> 필터적용</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- 리스트 시작 -->
        <v-container style="max-width: 1200px;">
          <v-flex class="filter-wrap">
            <div class="filter-box">
              <div class="filter-title">매물 유형</div>
              <div>
                <button type="button" class="select-btn" :class="(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1)? 'select-btn-active' : ''" @click="clickItemType(0, true)">전체</button>
                <button type="button" class="select-btn" :class="!(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1) && filterState.itemType.opt1 === 1? 'select-btn-active' : ''" @click="clickItemType(1, true)">원룸</button>
                <button type="button" class="select-btn" :class="!(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1) && filterState.itemType.opt2 === 1? 'select-btn-active' : ''" @click="clickItemType(2, true)">투룸</button>
                <button type="button" class="select-btn" :class="!(filterState.itemType.opt1 === 1 && filterState.itemType.opt2 === 1 && filterState.itemType.opt3 === 1) && filterState.itemType.opt3 === 1? 'select-btn-active' : ''" @click="clickItemType(3, true)">쓰리룸+</button>
                <!-- -->
                <button type="button" class="select-btn ml-4" :class="filterState.itemType.opt4 === 1? 'select-btn-active' : ''" @click="clickItemType(4)">빌라분양/매매</button>
                <button type="button" class="select-btn" :class="filterState.itemType.opt5 === 1? 'select-btn-active' : ''" @click="clickItemType(5)">상가/사무실</button>
              </div>
            </div>
            <div class="filter-box">
              <div class="filter-title">거래 유형</div>
              <div>
                <button type="button" class="select-btn" :class="(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1)? 'select-btn-active' : ''" @click="clickSaleType(0, true)">전체</button>
                <button type="button" class="select-btn" :class="(!(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1) && filterState.saleType.opt1 === 1)? 'select-btn-active' : ''" @click="clickSaleType(1, true)">월세</button>
                <button type="button" class="select-btn" :class="(!(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1) && filterState.saleType.opt2 === 1)? 'select-btn-active' : ''" @click="clickSaleType(2, true)">전세</button>
                <button type="button" class="select-btn" :class="(!(filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1 && filterState.saleType.opt3 === 1) && filterState.saleType.opt3 === 1)? 'select-btn-active' : ''" @click="clickSaleType(3, true)">매매</button>
                <button type="button" class="select-btn ml-4" v-if="filterState.saleType.opt1 === 1" :class="filterState.mCost === 1? 'select-btn-active' : ''" @click="filterState.mCost === 1? filterState.mCost = 0 : filterState.mCost = 1">관리비포함(월세)</button>
              </div>
            </div>
            <div class="filter-box" v-if="filterState.saleType.opt1 === 1 || filterState.saleType.opt2 === 1 || filterState.saleType.opt3 === 1">
              <div v-if="filterState.saleType.opt1 === 1 || filterState.saleType.opt2 === 1">
                <div class="filter-title"><span v-if="filterState.saleType.opt1 === 1">보증금</span><span v-if="filterState.saleType.opt1 === 1 && filterState.saleType.opt2 === 1">/</span><span v-if="filterState.saleType.opt2 === 1">전세</span></div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.depositStep"
                      :max="44"
                      :min="0"
                      style="padding:0 10px;"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printDeposit}}
                  </div>
                </div>
              </div>
              <div v-if="filterState.saleType.opt1 === 1">
                <div class="filter-title">월세</div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.monthlyStep"
                      :max="30"
                      :min="0"
                      style="padding:0 10px;"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printMonthly}}
                  </div>
                </div>
              </div>
              <div v-if="filterState.saleType.opt3 === 1">
                <div class="filter-title">매매가</div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.salePriceStep"
                      :max="25"
                      :min="0"
                      style="padding:0 10px;"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printSalePrice}}
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-box" v-if="filterState.itemType.opt1 === 1">
              <div class="filter-title">원룸 구조</div>
              <div>
                <button type="button" class="select-btn" :class="(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1 && filterState.structType.opt4 === 1)? 'select-btn-active' : ''" @click="clickStructType(0, true)">전체</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt1 === 1? 'select-btn-active' : ''" @click="clickStructType(1, true)">오픈형</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt3 === 1? 'select-btn-active' : ''" @click="clickStructType(3, true)">분리형(주방)</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt4 === 1? 'select-btn-active' : ''" @click="clickStructType(4, true)">1.5(거실&주방)</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt1 === 1 && filterState.structType.opt2 === 1 && filterState.structType.opt3 === 1) && filterState.structType.opt2 === 1? 'select-btn-active' : ''" @click="clickStructType(2, true)">복층</button>
              </div>
            </div>
            <div class="filter-box" v-if="filterState.itemType.opt2 === 1 || filterState.itemType.opt3 === 1">
              <div class="filter-title">투/쓰리룸+ 구조</div>
              <div>
                <button type="button" class="select-btn" :class="(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1)? 'select-btn-active' : ''" @click="clickStructType(5, true)">전체</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1) && filterState.structType.opt6 === 1? 'select-btn-active' : ''" @click="clickStructType(6, true)">거실(소)</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1) && filterState.structType.opt7 === 1? 'select-btn-active' : ''" @click="clickStructType(7, true)">거실(중)</button>
                <button type="button" class="select-btn" :class="!(filterState.structType.opt6 === 1 && filterState.structType.opt7 === 1 && filterState.structType.opt8 === 1) && filterState.structType.opt8 === 1? 'select-btn-active' : ''" @click="clickStructType(8, true)">거실(대)</button>
              </div>
            </div>
            <div class="filter-box" style="display: none;">
              <div>
                <div class="filter-title">면적</div>
                <div class="filter-slider">
                  <v-flex style="position: relative;">
                    <v-range-slider
                      v-model="filterState.m2Step"
                      :max="10"
                      :min="0"
                      style="padding:0 10px;"
                    ></v-range-slider>
                    <v-flex class="filter-slider-guide">
                      <span style="float: left; margin-left:5px;">0</span>
                      <span style="float: right; margin-right:-8px;">무제한</span>
                    </v-flex>
                  </v-flex>
                  <div class="filter-slider-print">
                    {{printM2()}}
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-box">
              <div class="filter-title">층수</div>
              <div>
                <button type="button" class="select-btn" :class="(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1)? 'select-btn-active' : ''" @click="clickItemFloor(0, true)">전체</button>
                <button type="button" class="select-btn" :class="!(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1) && filterState.itemFloor.opt1 === 1? 'select-btn-active' : ''" @click="clickItemFloor(1, true)">지상층</button>
                <button type="button" class="select-btn" :class="!(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1) && filterState.itemFloor.opt8 === 1? 'select-btn-active' : ''" @click="clickItemFloor(8, true)">반지층</button>
                <button type="button" class="select-btn" :class="!(filterState.itemFloor.opt1 === 1 && filterState.itemFloor.opt8 === 1 && filterState.itemFloor.opt9 === 1) && filterState.itemFloor.opt9 === 1? 'select-btn-active' : ''" @click="clickItemFloor(9, true)">옥탑</button>
              </div>
            </div>
            <div class="filter-box">
              <div class="filter-title">준공 년차</div>
              <div>
                <button type="button" class="select-btn" :class="filterState.approvalDate === 0? 'select-btn-active' : ''" @click="filterState.approvalDate = 0">전체</button>
                <button type="button" class="select-btn" :class="filterState.approvalDate === 1? 'select-btn-active' : ''" @click="filterState.approvalDate = 1">1년이하</button>
                <button type="button" class="select-btn" :class="filterState.approvalDate === 2? 'select-btn-active' : ''" @click="filterState.approvalDate = 2">5년이하</button>
                <button type="button" class="select-btn" :class="filterState.approvalDate === 3? 'select-btn-active' : ''" @click="filterState.approvalDate = 3">10년이하</button>
                <button type="button" class="select-btn" :class="filterState.approvalDate === 4? 'select-btn-active' : ''" @click="filterState.approvalDate = 4">15년이하</button>
                <button type="button" class="select-btn" :class="filterState.approvalDate === 5? 'select-btn-active' : ''" @click="filterState.approvalDate = 5">15년이상</button>
              </div>
            </div>
            <div class="filter-box">
              <div class="filter-title">옵션 필터 선택</div>
              <div>
                <button type="button" class="select-btn" :class="filterState.roomOption.opt1 === 1? 'select-btn-active' : ''" @click="filterState.roomOption.opt1 === 1? filterState.roomOption.opt1 = 0 : filterState.roomOption.opt1 = 1">발코니</button>
                <button type="button" class="select-btn" :class="filterState.roomOption.opt2 === 1? 'select-btn-active' : ''" @click="filterState.roomOption.opt2 === 1? filterState.roomOption.opt2 = 0 : filterState.roomOption.opt2 = 1">빌트인</button>
                <button type="button" class="select-btn" :class="filterState.roomOption.opt3 === 1? 'select-btn-active' : ''" @click="filterState.roomOption.opt3 === 1? filterState.roomOption.opt3 = 0 : filterState.roomOption.opt3 = 1">동물가능</button>
                <button type="button" class="select-btn" :class="filterState.roomOption.opt4 === 1? 'select-btn-active' : ''" @click="filterState.roomOption.opt4 === 1? filterState.roomOption.opt4 = 0 : filterState.roomOption.opt4 = 1">전세자금대출</button>
                <button type="button" class="select-btn" :class="filterState.roomOption.opt5 === 1? 'select-btn-active' : ''" @click="filterState.roomOption.opt5 === 1? filterState.roomOption.opt5 = 0 : filterState.roomOption.opt5 = 1">비옵션(주택)</button>
              </div>
            </div>
            <div class="filter-box">
              <div class="filter-title">이미지 필터 선택</div>
              <div>
                <button type="button" class="select-btn" :class="filterState.imgOption.opt1 === 1? 'select-btn-active' : ''" @click="filterState.imgOption.opt1 === 1? filterState.imgOption.opt1 = 0 : filterState.imgOption.opt1 = 1">동영상</button>
                <button type="button" class="select-btn" :class="filterState.imgOption.opt2 === 1? 'select-btn-active' : ''" @click="filterState.imgOption.opt2 === 1? filterState.imgOption.opt2 = 0 : filterState.imgOption.opt2 = 1">사진</button>
                <button type="button" class="select-btn" :class="filterState.imgOption.opt3 === 1? 'select-btn-active' : ''" @click="filterState.imgOption.opt3 === 1? filterState.imgOption.opt3 = 0 : filterState.imgOption.opt3 = 1">2D</button>
                <button type="button" class="select-btn" :class="filterState.imgOption.opt4 === 1? 'select-btn-active' : ''" @click="filterState.imgOption.opt4 === 1? filterState.imgOption.opt4 = 0 : filterState.imgOption.opt4 = 1">3D</button>
                <button type="button" class="select-btn" :class="filterState.imgOption.opt5 === 1? 'select-btn-active' : ''" @click="filterState.imgOption.opt5 === 1? filterState.imgOption.opt5 = 0 : filterState.imgOption.opt5 = 1">VR</button>
              </div>
            </div>
            <v-flex class="mt-3 mb-3 clearfix">
              <div style="float:right;">
                <v-btn color="title_dark1" class="mr-1" dark @click="filterReset()"><v-icon>refresh</v-icon> 초기화</v-btn>
                <v-btn color="title_dark1" dark @click="filterSave()"><v-icon>done</v-icon> 필터적용</v-btn>
              </div>
            </v-flex>
          </v-flex>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import IconHashTag from '../../svg/IconHashTag'
import EventBus from '@/utile/eventBus'

import SvgLogo from '../../svg/Logo'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'MapOptionBar',
  data: () => ({
    filter_dialog: false,
    mini_filter: {
      opt_1: {
        show: false,
        left: 0
      },
      opt_2: {
        show: false,
        left: 0
      },
      opt_3: {
        show: false,
        left: 0
      },
      opt_4: {
        show: false,
        left: 0
      },
      opt_5: {
        show: false,
        left: 0
      }
    },
    autoMapUpdateTimer: null
  }),
  computed: {
    ...mapState({
      filterState: state => state.mapData.filterState,
      mapData: state => state.mapData,
      auth: state => state.auth
    }),
    getViewType () {
      return this.$store.state.mapData.filterState.viewType
    },
    printDeposit () {
      return this.$store.getters['mapData/printDeposit'](this.mapData.filterState.depositStep[0], this.mapData.filterState.depositStep[1])
    },
    printMonthly () {
      return this.$store.getters['mapData/printMonthly'](this.mapData.filterState.monthlyStep[0], this.mapData.filterState.monthlyStep[1])
    },
    printSalePrice () {
      return this.$store.getters['mapData/printSalePrice'](this.mapData.filterState.salePriceStep[0], this.mapData.filterState.salePriceStep[1])
    }
  },
  mounted () {
    // 검색 완성창 종료를 위한
    const mapData = this.mapData
    const miniFilter = this.mini_filter
    document.body.onclick = function () {
      let obj = document.getElementById('search-auto-wrap')
      // eslint-disable-next-line no-caller
      let e = window.event || arguments.callee.caller.arguments[0]
      let eobj = e.target ? e.target : e.srcElement
      while (eobj.parentNode) {
        if (eobj === obj) {
          return false
        }
        eobj = eobj.parentNode
      }
      mapData.searchAutoView.show = false
      //
      let obj1 = document.getElementsByClassName('opt-chip')
      let obj2 = document.getElementsByClassName('mini-filter')
      // eslint-disable-next-line no-caller
      e = window.event || arguments.callee.caller.arguments[0]
      eobj = e.target ? e.target : e.srcElement
      while (eobj.parentNode) {
        for (let i = 0; i < obj1.length; i++) {
          if (eobj === obj1[i]) {
            return false
          }
        }
        for (let i = 0; i < obj2.length; i++) {
          if (eobj === obj2[i]) {
            return false
          }
        }
        eobj = eobj.parentNode
      }
      miniFilter.opt_1.show = false
      miniFilter.opt_2.show = false
      miniFilter.opt_3.show = false
      miniFilter.opt_4.show = false
      miniFilter.opt_5.show = false
    }
  },
  methods: {
    ...mapActions({
      // filterReset: 'mapData/filterReset'
      filterSaleTypeReset: 'mapData/filterSaleTypeReset',
      filterPriceReset: 'mapData/filterPriceReset'
    }),
    ...mapGetters({
      // printDeposit: 'mapData/printDeposit',
      // printMonthly: 'mapData/printMonthly',
      // printSalePrice: 'mapData/printSalePrice',
      printM2: 'mapData/printM2',
      printM2Info: 'mapData/printM2Info',
      printDateInfo: 'mapData/printDateInfo',
      printItemTypeInfo: 'mapData/printItemTypeInfo',
      printSaleTypeInfo: 'mapData/printSaleTypeInfo',
      printPriceInfo: 'mapData/printPriceInfo'
    }),
    openVideoModal () {
      this.$router.replace({path: 'modal', query: { video: 1 }})
    },
    searchInputClick () {
      if (this.mapData.filterState.search !== '') {
        EventBus.$emit('searchAuto', this.mapData.filterState.search)
      }
    },
    showMiniFilter (obj, num) {
      this.mini_filter.opt_1.show = false
      this.mini_filter.opt_2.show = false
      this.mini_filter.opt_3.show = false
      this.mini_filter.opt_4.show = false
      this.mini_filter.opt_5.show = false
      switch (num) {
        case 1: {
          const el = this.$refs.mini_filter_btn_1.$el
          this.mini_filter.opt_1.left = el.offsetLeft + 'px'
          this.mini_filter.opt_1.show = true
          break
        }
        case 2: {
          const el = this.$refs.mini_filter_btn_2.$el
          this.mini_filter.opt_2.left = el.offsetLeft + 'px'
          this.mini_filter.opt_2.show = true
          break
        }
        case 3: {
          const el = this.$refs.mini_filter_btn_3.$el
          this.mini_filter.opt_3.left = el.offsetLeft + 'px'
          this.mini_filter.opt_3.show = true
          break
        }
        case 4: {
          const el = this.$refs.mini_filter_btn_4.$el
          this.mini_filter.opt_4.left = el.offsetLeft + 'px'
          this.mini_filter.opt_4.show = true
          break
        }
        case 5: {
          const el = this.$refs.mini_filter_btn_5.$el
          this.mini_filter.opt_5.left = el.offsetLeft + 'px'
          this.mini_filter.opt_5.show = true
          break
        }
      }
    },
    searchAutoAction (type, no, level, lat, lng) {
      if (type === 'structure' || type === 'structure_addr') {
        this.$router.replace({path: 'map', query: { no: 'b' + no }})
      } else if (type === 'subway' || type === 'dong') {
        EventBus.$emit('moveCenter', lat, lng, level)
      }
      this.mapData.searchAutoView.show = false
    },
    getSearchAutoIcon (type) {
      if (type === 'structure' || type === 'structure_addr') {
        return 'business'
      } else if (type === 'subway') {
        return 'train'
      } else {
        return 'location_searching'
      }
    },
    submit () {
      if (this.filterState.search !== '' && this.filterState.search.length > 1) {
        document.getElementById('search_box').blur()
        EventBus.$emit('searchMap')
      }
    },
    home () {
      EventBus.$emit('resetMapState')
    },
    filterSave () {
      this.filter_dialog = false
      this.$store.dispatch('mapData/filterSave')
      EventBus.$emit('updateMap', 'filterSave')
    },
    filterReset () {
      this.filter_dialog = false
      this.$store.dispatch('mapData/filterReset')
      EventBus.$emit('updateMap', 'filterReset')
    },
    // 자동 새로고침
    autoMapUpdate () {
      if (this.autoMapUpdateTimer != null) {
        clearTimeout(this.autoMapUpdateTimer)
        this.autoMapUpdateTimer = null
      }
      this.autoMapUpdateTimer = setTimeout(() => {
        EventBus.$emit('updateMap', 'autoMapUpdate')
      }, 1000)
    },
    // 준공년
    clickApprovalDate (type, auto = false) {
      switch (type) {
        case 0: {
          this.filterState.approvalDate = 0
          break
        }
        case 1: {
          this.filterState.approvalDate = 1
          break
        }
        case 2: {
          this.filterState.approvalDate = 2
          break
        }
        case 3: {
          this.filterState.approvalDate = 3
          break
        }
        case 4: {
          this.filterState.approvalDate = 4
          break
        }
        case 5: {
          this.filterState.approvalDate = 5
          break
        }
      }
      if (auto) this.autoMapUpdate()
    },
    // 룸 구조
    clickStructType (type, auto = false) {
      switch (type) {
        case 0: {
          this.filterState.structType.opt1 = 1
          this.filterState.structType.opt2 = 1
          this.filterState.structType.opt3 = 1
          this.filterState.structType.opt4 = 1
          break
        }
        case 1: {
          if (this.filterState.structType.opt1 === 1 && this.filterState.structType.opt2 === 1 && this.filterState.structType.opt3 === 1 && this.filterState.structType.opt4 === 1) {
            this.filterState.structType.opt1 = 1
            this.filterState.structType.opt2 = 0
            this.filterState.structType.opt3 = 0
            this.filterState.structType.opt4 = 0
          } else {
            this.filterState.structType.opt1 === 1 ? this.filterState.structType.opt1 = 0 : this.filterState.structType.opt1 = 1
          }
          break
        }
        case 2: {
          if (this.filterState.structType.opt1 === 1 && this.filterState.structType.opt2 === 1 && this.filterState.structType.opt3 === 1 && this.filterState.structType.opt4 === 1) {
            this.filterState.structType.opt1 = 0
            this.filterState.structType.opt2 = 1
            this.filterState.structType.opt3 = 0
            this.filterState.structType.opt4 = 0
          } else {
            this.filterState.structType.opt2 === 1 ? this.filterState.structType.opt2 = 0 : this.filterState.structType.opt2 = 1
          }
          break
        }
        case 3: {
          if (this.filterState.structType.opt1 === 1 && this.filterState.structType.opt2 === 1 && this.filterState.structType.opt3 === 1 && this.filterState.structType.opt4 === 1) {
            this.filterState.structType.opt1 = 0
            this.filterState.structType.opt2 = 0
            this.filterState.structType.opt3 = 1
            this.filterState.structType.opt4 = 0
          } else {
            this.filterState.structType.opt3 === 1 ? this.filterState.structType.opt3 = 0 : this.filterState.structType.opt3 = 1
          }
          break
        }
        case 4: {
          if (this.filterState.structType.opt1 === 1 && this.filterState.structType.opt2 === 1 && this.filterState.structType.opt3 === 1 && this.filterState.structType.opt4 === 1) {
            this.filterState.structType.opt1 = 0
            this.filterState.structType.opt2 = 0
            this.filterState.structType.opt3 = 0
            this.filterState.structType.opt4 = 1
          } else {
            this.filterState.structType.opt4 === 1 ? this.filterState.structType.opt4 = 0 : this.filterState.structType.opt4 = 1
          }
          break
        }
        case 5: {
          this.filterState.structType.opt6 = 1
          this.filterState.structType.opt7 = 1
          this.filterState.structType.opt8 = 1
          break
        }
        case 6: {
          if (this.filterState.structType.opt6 === 1 && this.filterState.structType.opt7 === 1 && this.filterState.structType.opt8 === 1) {
            this.filterState.structType.opt6 = 1
            this.filterState.structType.opt7 = 0
            this.filterState.structType.opt8 = 0
          } else {
            this.filterState.structType.opt6 === 1 ? this.filterState.structType.opt6 = 0 : this.filterState.structType.opt6 = 1
          }
          break
        }
        case 7: {
          if (this.filterState.structType.opt6 === 1 && this.filterState.structType.opt7 === 1 && this.filterState.structType.opt8 === 1) {
            this.filterState.structType.opt6 = 0
            this.filterState.structType.opt7 = 1
            this.filterState.structType.opt8 = 0
          } else {
            this.filterState.structType.opt7 === 1 ? this.filterState.structType.opt7 = 0 : this.filterState.structType.opt7 = 1
          }
          break
        }
        case 8: {
          if (this.filterState.structType.opt6 === 1 && this.filterState.structType.opt7 === 1 && this.filterState.structType.opt8 === 1) {
            this.filterState.structType.opt6 = 0
            this.filterState.structType.opt7 = 0
            this.filterState.structType.opt8 = 1
          } else {
            this.filterState.structType.opt8 === 1 ? this.filterState.structType.opt8 = 0 : this.filterState.structType.opt8 = 1
          }
          break
        }
      }
      if (auto) this.autoMapUpdate()
    },
    // 층옵션 클릭
    clickItemFloor (type, auto = false) {
      switch (type) {
        case 0: {
          this.filterState.itemFloor.opt1 = 1
          this.filterState.itemFloor.opt8 = 1
          this.filterState.itemFloor.opt9 = 1
          break
        }
        case 1: {
          if (this.filterState.itemFloor.opt1 === 1 && this.filterState.itemFloor.opt8 === 1 && this.filterState.itemFloor.opt9 === 1) {
            this.filterState.itemFloor.opt1 = 1
            this.filterState.itemFloor.opt8 = 0
            this.filterState.itemFloor.opt9 = 0
          } else {
            this.filterState.itemFloor.opt1 === 1 ? this.filterState.itemFloor.opt1 = 0 : this.filterState.itemFloor.opt1 = 1
          }
          break
        }
        case 8: {
          if (this.filterState.itemFloor.opt1 === 1 && this.filterState.itemFloor.opt8 === 1 && this.filterState.itemFloor.opt9 === 1) {
            this.filterState.itemFloor.opt1 = 0
            this.filterState.itemFloor.opt8 = 1
            this.filterState.itemFloor.opt9 = 0
          } else {
            this.filterState.itemFloor.opt8 === 1 ? this.filterState.itemFloor.opt8 = 0 : this.filterState.itemFloor.opt8 = 1
          }
          break
        }
        case 9: {
          if (this.filterState.itemFloor.opt1 === 1 && this.filterState.itemFloor.opt8 === 1 && this.filterState.itemFloor.opt9 === 1) {
            this.filterState.itemFloor.opt1 = 0
            this.filterState.itemFloor.opt8 = 0
            this.filterState.itemFloor.opt9 = 1
          } else {
            this.filterState.itemFloor.opt9 === 1 ? this.filterState.itemFloor.opt9 = 0 : this.filterState.itemFloor.opt9 = 1
          }
          break
        }
      }
      if (auto) this.autoMapUpdate()
    },
    // 룸옵션 클릭
    clickRoomOption (type, auto = false) {
      switch (type) {
        case 1: {
          this.filterState.roomOption.opt1 === 1 ? this.filterState.roomOption.opt1 = 0 : this.filterState.roomOption.opt1 = 1
          break
        }
        case 2: {
          this.filterState.roomOption.opt2 === 1 ? this.filterState.roomOption.opt2 = 0 : this.filterState.roomOption.opt2 = 1
          break
        }
        case 3: {
          this.filterState.roomOption.opt3 === 1 ? this.filterState.roomOption.opt3 = 0 : this.filterState.roomOption.opt3 = 1
          break
        }
        case 4: {
          this.filterState.roomOption.opt4 === 1 ? this.filterState.roomOption.opt4 = 0 : this.filterState.roomOption.opt4 = 1
          break
        }
        case 5: {
          this.filterState.roomOption.opt5 === 1 ? this.filterState.roomOption.opt5 = 0 : this.filterState.roomOption.opt5 = 1
          break
        }
      }
      if (auto) this.autoMapUpdate()
    },
    // 사진
    clickImgOption (type, auto = false) {
      switch (type) {
        case 1: {
          this.filterState.imgOption.opt1 === 1 ? this.filterState.imgOption.opt1 = 0 : this.filterState.imgOption.opt1 = 1
          break
        }
        case 2: {
          this.filterState.imgOption.opt2 === 1 ? this.filterState.imgOption.opt2 = 0 : this.filterState.imgOption.opt2 = 1
          break
        }
        case 3: {
          this.filterState.imgOption.opt3 === 1 ? this.filterState.imgOption.opt3 = 0 : this.filterState.imgOption.opt3 = 1
          break
        }
        case 4: {
          this.filterState.imgOption.opt4 === 1 ? this.filterState.imgOption.opt4 = 0 : this.filterState.imgOption.opt4 = 1
          break
        }
        case 5: {
          this.filterState.imgOption.opt5 === 1 ? this.filterState.imgOption.opt5 = 0 : this.filterState.imgOption.opt5 = 1
          break
        }
      }
      if (auto) this.autoMapUpdate()
    },
    // 거래유형 클릭
    clickSaleType (type, auto = false) {
      switch (type) {
        case 0: { // 전체버튼 클릭
          this.filterState.saleType.opt1 = 1
          this.filterState.saleType.opt2 = 1
          this.filterState.saleType.opt3 = 1
          break
        }
        case 1: {
          if (this.filterState.saleType.opt1 === 1 && this.filterState.saleType.opt2 === 1 && this.filterState.saleType.opt3 === 1) {
            this.filterState.saleType.opt1 = 1
            this.filterState.saleType.opt2 = 0
            this.filterState.saleType.opt3 = 0
          } else {
            (this.filterState.saleType.opt1 === 1) ? this.filterState.saleType.opt1 = 0 : this.filterState.saleType.opt1 = 1
          }
          break
        }
        case 2: {
          if (this.filterState.saleType.opt1 === 1 && this.filterState.saleType.opt2 === 1 && this.filterState.saleType.opt3 === 1) {
            this.filterState.saleType.opt1 = 0
            this.filterState.saleType.opt2 = 1
            this.filterState.saleType.opt3 = 0
          } else {
            (this.filterState.saleType.opt2 === 1) ? this.filterState.saleType.opt2 = 0 : this.filterState.saleType.opt2 = 1
          }
          break
        }
        case 3: {
          if (this.filterState.saleType.opt1 === 1 && this.filterState.saleType.opt2 === 1 && this.filterState.saleType.opt3 === 1) {
            this.filterState.saleType.opt1 = 0
            this.filterState.saleType.opt2 = 0
            this.filterState.saleType.opt3 = 1
          } else {
            (this.filterState.saleType.opt3 === 1) ? this.filterState.saleType.opt3 = 0 : this.filterState.saleType.opt3 = 1
          }
          break
        }
      }
      if (auto) this.autoMapUpdate()
    },
    // 매물 종류 클릭
    clickItemType (type, auto = false) {
      switch (type) {
        case 0: {
          this.$store.state.mapData.filterState.itemType.opt1 = 1
          this.$store.state.mapData.filterState.itemType.opt2 = 1
          this.$store.state.mapData.filterState.itemType.opt3 = 1
          // 기타
          this.$store.state.mapData.filterState.itemType.opt4 = 0
          this.$store.state.mapData.filterState.itemType.opt5 = 0
          this.$store.state.mapData.filterState.structType.opt1 = 1
          this.$store.state.mapData.filterState.structType.opt2 = 1
          this.$store.state.mapData.filterState.structType.opt3 = 1
          this.$store.state.mapData.filterState.structType.opt4 = 1
          this.$store.state.mapData.filterState.saleType.opt1 = 1
          this.$store.state.mapData.filterState.saleType.opt2 = 1
          this.$store.state.mapData.filterState.saleType.opt3 = 1
          break
        }
        case 1: {
          if (this.$store.state.mapData.filterState.itemType.opt1 === 1 && this.$store.state.mapData.filterState.itemType.opt2 === 1 && this.$store.state.mapData.filterState.itemType.opt3 === 1) {
            this.$store.state.mapData.filterState.itemType.opt1 = 1
            this.$store.state.mapData.filterState.itemType.opt2 = 0
            this.$store.state.mapData.filterState.itemType.opt3 = 0

            this.$store.state.mapData.filterState.itemType.opt4 = 0
            this.$store.state.mapData.filterState.itemType.opt5 = 0
            this.$store.state.mapData.filterState.structType.opt1 = 1
            this.$store.state.mapData.filterState.structType.opt2 = 1
            this.$store.state.mapData.filterState.structType.opt3 = 1
            this.$store.state.mapData.filterState.structType.opt4 = 1
            this.$store.state.mapData.filterState.saleType.opt1 = 1
            this.$store.state.mapData.filterState.saleType.opt2 = 1
            this.$store.state.mapData.filterState.saleType.opt3 = 1
          } else {
            if (this.$store.state.mapData.filterState.itemType.opt1 === 1) {
              this.$store.state.mapData.filterState.itemType.opt1 = 0
            } else {
              this.$store.state.mapData.filterState.itemType.opt1 = 1
              this.$store.state.mapData.filterState.itemType.opt4 = 0
              this.$store.state.mapData.filterState.itemType.opt5 = 0
              this.$store.state.mapData.filterState.structType.opt1 = 1
              this.$store.state.mapData.filterState.structType.opt2 = 1
              this.$store.state.mapData.filterState.structType.opt3 = 1
              this.$store.state.mapData.filterState.structType.opt4 = 1
              this.$store.state.mapData.filterState.saleType.opt1 = 1
              this.$store.state.mapData.filterState.saleType.opt2 = 1
              this.$store.state.mapData.filterState.saleType.opt3 = 1
            }
          }
          break
        }
        case 2: {
          if (this.$store.state.mapData.filterState.itemType.opt1 === 1 && this.$store.state.mapData.filterState.itemType.opt2 === 1 && this.$store.state.mapData.filterState.itemType.opt3 === 1) {
            this.$store.state.mapData.filterState.itemType.opt1 = 0
            this.$store.state.mapData.filterState.itemType.opt2 = 1
            this.$store.state.mapData.filterState.itemType.opt3 = 0

            this.$store.state.mapData.filterState.itemType.opt4 = 0
            this.$store.state.mapData.filterState.itemType.opt5 = 0
            this.$store.state.mapData.filterState.structType.opt1 = 1
            this.$store.state.mapData.filterState.structType.opt2 = 1
            this.$store.state.mapData.filterState.structType.opt3 = 1
            this.$store.state.mapData.filterState.structType.opt4 = 1
            this.$store.state.mapData.filterState.saleType.opt1 = 1
            this.$store.state.mapData.filterState.saleType.opt2 = 1
            this.$store.state.mapData.filterState.saleType.opt3 = 1
          } else {
            if (this.$store.state.mapData.filterState.itemType.opt2 === 1) {
              this.$store.state.mapData.filterState.itemType.opt2 = 0
            } else {
              this.$store.state.mapData.filterState.itemType.opt2 = 1
              this.$store.state.mapData.filterState.itemType.opt4 = 0
              this.$store.state.mapData.filterState.itemType.opt5 = 0
              this.$store.state.mapData.filterState.structType.opt6 = 1
              this.$store.state.mapData.filterState.structType.opt7 = 1
              this.$store.state.mapData.filterState.structType.opt8 = 1
              this.$store.state.mapData.filterState.saleType.opt1 = 1
              this.$store.state.mapData.filterState.saleType.opt2 = 1
              this.$store.state.mapData.filterState.saleType.opt3 = 1
            }
          }
          break
        }
        case 3: {
          if (this.$store.state.mapData.filterState.itemType.opt1 === 1 && this.$store.state.mapData.filterState.itemType.opt2 === 1 && this.$store.state.mapData.filterState.itemType.opt3 === 1) {
            this.$store.state.mapData.filterState.itemType.opt1 = 0
            this.$store.state.mapData.filterState.itemType.opt2 = 0
            this.$store.state.mapData.filterState.itemType.opt3 = 1

            this.$store.state.mapData.filterState.itemType.opt4 = 0
            this.$store.state.mapData.filterState.itemType.opt5 = 0
            this.$store.state.mapData.filterState.structType.opt1 = 1
            this.$store.state.mapData.filterState.structType.opt2 = 1
            this.$store.state.mapData.filterState.structType.opt3 = 1
            this.$store.state.mapData.filterState.structType.opt4 = 1
            this.$store.state.mapData.filterState.saleType.opt1 = 1
            this.$store.state.mapData.filterState.saleType.opt2 = 1
            this.$store.state.mapData.filterState.saleType.opt3 = 1
          } else {
            if (this.$store.state.mapData.filterState.itemType.opt3 === 1) {
              this.$store.state.mapData.filterState.itemType.opt3 = 0
            } else {
              this.$store.state.mapData.filterState.itemType.opt3 = 1
              this.$store.state.mapData.filterState.itemType.opt4 = 0
              this.$store.state.mapData.filterState.itemType.opt5 = 0
              this.$store.state.mapData.filterState.structType.opt6 = 1
              this.$store.state.mapData.filterState.structType.opt7 = 1
              this.$store.state.mapData.filterState.structType.opt8 = 1
              this.$store.state.mapData.filterState.saleType.opt1 = 1
              this.$store.state.mapData.filterState.saleType.opt2 = 1
              this.$store.state.mapData.filterState.saleType.opt3 = 1
            }
          }
          break
        }
        case 4: {
          if (this.$store.state.mapData.filterState.itemType.opt4 === 1) {
            this.$store.state.mapData.filterState.itemType.opt4 = 0
          } else {
            this.$store.state.mapData.filterState.itemType.opt4 = 1

            this.$store.state.mapData.filterState.itemType.opt1 = 0
            this.$store.state.mapData.filterState.itemType.opt2 = 0
            this.$store.state.mapData.filterState.itemType.opt3 = 0
            this.$store.state.mapData.filterState.itemType.opt5 = 0
            this.$store.state.mapData.filterState.saleType.opt1 = 1
            this.$store.state.mapData.filterState.saleType.opt2 = 1
            this.$store.state.mapData.filterState.saleType.opt3 = 1
          }
          break
        }
        case 5: {
          if (this.$store.state.mapData.filterState.itemType.opt5 === 1) {
            this.$store.state.mapData.filterState.itemType.opt5 = 0
          } else {
            this.$store.state.mapData.filterState.itemType.opt5 = 1

            this.$store.state.mapData.filterState.itemType.opt1 = 0
            this.$store.state.mapData.filterState.itemType.opt2 = 0
            this.$store.state.mapData.filterState.itemType.opt3 = 0
            this.$store.state.mapData.filterState.itemType.opt4 = 0

            this.$store.state.mapData.filterState.saleType.opt1 = 1
            this.$store.state.mapData.filterState.saleType.opt2 = 1
            this.$store.state.mapData.filterState.saleType.opt3 = 1
          }
          break
        }
      }
      if (auto) this.autoMapUpdate()
    }
  },
  components: {
    IconHashTag, SvgLogo
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/map/MapOptionBar.vue